import { render, staticRenderFns } from "./ChangeCustomerInfo.vue?vue&type=template&id=00c06073&scoped=true&lang=pug"
import script from "./ChangeCustomerInfo.vue?vue&type=script&lang=js"
export * from "./ChangeCustomerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c06073",
  null
  
)

export default component.exports